export default {"src":"/_next/static/media/0x8f552a71efe5eefc207bf75485b356a0b3f01ec9.6f7cbaef.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};